import React from 'react';
import PropTypes from 'prop-types';

import logger from '../../utils/logger';
import errorImage from '../../assets/no_results.png';
import s from './ErrorBoundary.module.css';

export default class ErrorBoundary extends React.Component {
  static defaultProps = {
    clientHost: '',
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    logger(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={s.errorContainerCentered}>
          <img
            className={s.errorImage}
            src={`${this.props.clientHost}${errorImage}`}
            alt="error"
            aria-hidden
          />
          <div className={s.errorText}>
            <div className={s.errorTextTitle}>
              {'Oops! Something went wrong.'}
            </div>
            <div className={s.errorTextSubTitle}>
              {"Looks like what you were looking for can't be shown right now."}
            </div>
            <div className={s.errorTextSubTitle2}>
              {'Try reloading the page.'}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  clientHost: PropTypes.string,
  children: PropTypes.object,
};
